// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5639":"4d6ea00d","9124":"4363c7a2"}[chunkId] + ".chunk.css";
};